import manifest from "../data/imageManifest.json";

// Image paths moved from webpack `require()` to plain URL strings, which means a
// typo no longer fails the build — it 404s at runtime. This warns once per bad
// key so a mistake surfaces in the console instead of as a silently broken image.
const warned = new Set();

export function getImage(key) {
  const entry = manifest[key];
  if (!entry) {
    if (!warned.has(key)) {
      warned.add(key);
      console.error(
        `[images] no manifest entry for "${key}" — check the path, or re-run \`npm run images\``
      );
    }
    return null;
  }
  return entry;
}

// Widths the browser can choose between. Only WebP is generated at every tier;
// the fallback ships at a single width (see scripts/build-images.mjs).
export function webpSrcSet(key) {
  const entry = getImage(key);
  if (!entry) return undefined;
  return entry.widths.map((w) => `/img/w${w}/${key}.webp ${w}w`).join(", ");
}

export function fallbackSrc(key) {
  const entry = getImage(key);
  if (!entry) return undefined;
  return `/img/w${entry.fallbackWidth}/${key}${entry.ext}`;
}

// A single derivative at (or just above) the requested width.
//
// Use this instead of webpSrcSet for any antd <Image> that has a lightbox.
// rc-image copies `srcSet` and `sizes` onto the preview <img> alongside the
// preview's own `src` (they are in its COMMON_PROPS list), and a browser
// resolves srcSet in preference to src — so a grid srcSet would win and the
// full-screen preview would render the 400px thumbnail instead of the original.
export function srcAtWidth(key, width) {
  const entry = getImage(key);
  if (!entry) return undefined;
  const chosen =
    entry.widths.find((w) => w >= width) ?? entry.widths[entry.widths.length - 1];
  return `/img/w${chosen}/${key}.webp`;
}

// The untouched original, served only when someone opens the lightbox.
export function originalSrc(key) {
  const entry = getImage(key);
  return entry ? entry.full : undefined;
}
